import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';
import { useParams } from 'react-router-dom';

import { setCurrentVisitsAndScheduledTasksPageSliceTable } from '../Slice/visitsAndTasksSlice';
import { useManagePeriodReportModalStore } from '../Modals/createPeriodReportModal/ManagePeriodReportModalStore';
import { useManageVisitReportModalStore } from '../Modals/createVisitReportModal/MangeVisitReportModalStore';
import { useManageDigestReportModalStore } from '../Modals/createDigestReportModal/ManageDigestReportModalStore';

import { useAppDispatch, useAppSelector } from 'slices';
import './VisitAndPeriodReportsTitleTitle.scss';
import { VisitsAndScheduledTasksTableType } from 'components/VisitsAndScheduledTasks/visitsAndScheduledTasks';
import { MLButton } from 'components/Button/Button';

const CustomSelect = styled(Select)({
  '&.MuiInputBase-root': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderColor: 'red',
  },
  '& .MuiSelect-select': {
    padding: '10px 12px',
    paddingRight: '24px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E0E0E0',
  },
});

const VisitAndPeriodReportsTitleTitle: React.FC = () => {
  const { currentVisitsAndScheduledTasksTable } = useAppSelector(state => state.VisitsAndScheduledTasksTable);
  const dispatch = useAppDispatch();
  const pages: string[] = Object.values(VisitsAndScheduledTasksTableType).filter(
    page => page !== VisitsAndScheduledTasksTableType.VisitReports,
  );
  const { slug } = useParams();
  const { onManagePeriodVisitModalOpen: onCreatePeriodReportOpen } = useManagePeriodReportModalStore();
  const { onManageVisitReportModalOpen: onCreateVisitReportOpen } = useManageVisitReportModalStore();
  const { onManageDigestReportModalOpen: onCreateDigestReportOpen } = useManageDigestReportModalStore();
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    dispatch(setCurrentVisitsAndScheduledTasksPageSliceTable(event.target.value as VisitsAndScheduledTasksTableType));
  };
  const currentPageButton = () => {
    switch (currentVisitsAndScheduledTasksTable) {
      case VisitsAndScheduledTasksTableType.VisitReports:
        return (
          <MLButton
            onClick={() => onCreateVisitReportOpen(slug || '')}
            isGhost
            color="success"
            innerText="+ Visit Report"
          />
        );
      case VisitsAndScheduledTasksTableType.PeriodReports:
        return (
          <MLButton
            onClick={() => onCreatePeriodReportOpen(slug || '')}
            isGhost
            color="success"
            innerText="+ Period Report"
          />
        );
      case VisitsAndScheduledTasksTableType.DigestReports:
        return (
          <MLButton
            onClick={() => onCreateDigestReportOpen(slug || '')}
            isGhost
            color="success"
            innerText="+ Add Digest"
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className="table-title bg-white border-bottom">
      <div className="title">
        <div className="d-flex align-items-center h4 mb-0 fw-bold gap-2 ">{currentVisitsAndScheduledTasksTable}</div>
      </div>
      <div className="buttons">
        {currentPageButton()}
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="demo-simple-select-standard-label" sx={{ fontFamily: 'Poppins, sans-serif' }}>
            Chosen reports
          </InputLabel>
          <CustomSelect
            value={currentVisitsAndScheduledTasksTable}
            onChange={handleChange}
            id="demo-simple-select-filled"
            label="Current Traps Table"
            sx={{
              width: 250,
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--vz-purple)',
              },

              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--vz-purple)',
              },
            }}
          >
            {pages.map(pageName => (
              <MenuItem key={pageName} value={pageName} sx={{ fontFamily: 'Poppins, sans-serif' }}>
                {pageName}
              </MenuItem>
            ))}
          </CustomSelect>
        </FormControl>
      </div>
    </div>
  );
};

export default VisitAndPeriodReportsTitleTitle;
